import type { VideoDetails } from '..'

export default function getYouTubeID(url: string): VideoDetails | null {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[7].length === 11 ? { id: match[7] } : null
}
